import React from 'react';
import { useEffect } from 'react';
import './Carousel.scss';
console.clear();

const slides = [
  {
    title: "",
    subtitle: "",
    description: "",
    image:
      "https://pec.ac.in/sites/default/files/styles/home_page_slider/public/2022-01/cims_21_front_cover.jpg?itok=RiacbaRJ"
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
      "https://pec.ac.in/sites/default/files/styles/home_page_slider/public/2022-01/centenary_celebrations_pec_16-11-21_cover.jpg?itok=34D91hQ8"
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
      "https://media-exp1.licdn.com/dms/image/C4D22AQGHaHHgEreQbg/feedshare-shrink_800/0/1650892819467?e=2147483647&v=beta&t=m285j2PY1pJmqJGI3le_wUq0uzDxJFaWDzjGmVt5hTc"
  },
  {
    title: "",
    subtitle: "",
    description: "",
    image:
      "https://pec.ac.in/sites/default/files/styles/home_page_slider/public/2022-04/website_launch_0.JPG?itok=d1OpNVIw"
  },
//   {
//     title: "Five",
//     subtitle: "Australia",
//     description: "A piece of heaven",
//     image:
//       "https://images.unsplash.com/photo-1579130781921-76e18892b57b?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ"
//   }
];

function useTilt(active) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (!ref.current || !active) {
      return;
    }

    const state = {
      rect: undefined,
      mouseX: undefined,
      mouseY: undefined
    };

    let el = ref.current;

    const handleMouseMove = (e) => {
      if (!el) {
        return;
      }
      if (!state.rect) {
        state.rect = el.getBoundingClientRect();
      }
      state.mouseX = e.clientX;
      state.mouseY = e.clientY;
      const px = (state.mouseX - state.rect.left) / state.rect.width;
      const py = (state.mouseY - state.rect.top) / state.rect.height;

      el.style.setProperty("--px", px);
      el.style.setProperty("--py", py);
    };

    el.addEventListener("mousemove", handleMouseMove);

    return () => {
      el.removeEventListener("mousemove", handleMouseMove);
    };
  }, [active]);

  return ref;
}

const initialState = {
  slideIndex: 0
};


const slidesReducer = (state, event) => {
  if (event.type === "NEXT") {
    return {
      ...state,
      slideIndex: (state.slideIndex + 1) % slides.length
    };
  }
  if (event.type === "PREV") {
    return {
      ...state,
      slideIndex:
        state.slideIndex === 0 ? slides.length - 1 : state.slideIndex - 1
    };
  }
};

function Slide({ slide, offset }) {
  const active = offset === 0 ? true : null;
  const ref = useTilt(active);

  return (
    <div
      ref={ref}
      className="slide"
      data-active={active}
      style={{
        "--offset": offset,
        "--dir": offset === 0 ? 0 : offset > 0 ? 1 : -1
      }}
    >
      <div
        className="slideBackground"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      />
      <div
        className="slideContent"
        style={{
          backgroundImage: `url('${slide.image}')`
        }}
      >
        <div className="slideContentInner">
          <h2 className="slideTitle">{slide.title}</h2>
          <h3 className="slideSubtitle">{slide.subtitle}</h3>
          <p className="slideDescription">{slide.description}</p>
        </div>
      </div>
    </div>
  );
}

function App() {
  const [state, dispatch] = React.useReducer(slidesReducer, initialState);

  useEffect(() => {
    const interval = setInterval(() => {
      dispatch({type: "NEXT"});
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slides">
      <button onClick={() => dispatch({ type: "PREV" })}>‹</button>

      {[...slides, ...slides, ...slides].map((slide, i) => {
        let offset = slides.length + (state.slideIndex - i);
        return <Slide slide={slide} offset={offset} key={i} />;
      })}
      <button onClick={() => dispatch({ type: "NEXT" })}>›</button>
    </div>
  );
}


export default App
